import React from 'react'
// components
import ObjectProperties from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties'
// context
import ObjectsBL from 'containers/ObjectsAndProperties/Edit/layers/BL'

const ObjectPropertiesContainer: React.FC = () => (
  <ObjectsBL>
    <ObjectProperties />
  </ObjectsBL>
)

export default ObjectPropertiesContainer
